import { Photo } from 'tabler-icons-react';
import {
	SidebarStoryDetails,
	ReactLightbox,
	StoryAccordionTitle
} from 'Elements';
import styles from 'partials/story-box.module.scss';

export const StoryImages = ({ story, images, isOpen, onBack, type }) => {
	return (
		<SidebarStoryDetails
			story={story}
			isOpen={isOpen}
			onBack={onBack}
			type={type}>
			<StoryAccordionTitle
				isOpen
				title="تصاویر"
				icon={Photo}
				hasExpand={false}
			/>
			<div className={styles.content}>
				<ReactLightbox images={images} />
			</div>
		</SidebarStoryDetails>
	);
};
